import { Component, Input } from '@angular/core';
import { FilePreviewService } from './gf-file-preview.service';

@Component({
  selector: 'gf-file-preview',
  template: `<a (dblclick)="fileOpen()">
  <ng-content></ng-content>
</a>`
})
export class FilePreviewComponent {
  @Input() file: any;
  @Input() url!: string;
  @Input() isEnabled: boolean = true;

  constructor(private filePreviewService: FilePreviewService) { }

  fileOpen() {
    if (!this.isEnabled) return;
    this.filePreviewService.open(this.file, this.url);
  }
}




















